// extracted by mini-css-extract-plugin
module.exports = {"landingCtaSection":"LandingCtaSection_landingCtaSection__z2_0v","image":"LandingCtaSection_image__nFyJh","ctaButton":"LandingCtaSection_ctaButton__ZgSSD"};